import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  batteryInfo: {
    batteryPosInfo: [
      { batteryInfo: "abc", mount: false, batteryPos: "B1" },
      { batteryInfo: "abc", mount: false, batteryPos: "B2" },
      { batteryInfo: "abc", mount: true, batteryPos: "B3" },
      { batteryInfo: "", mount: false, batteryPos: "B4" },
      { batteryInfo: "", mount: false, batteryPos: "B5" },
    ],
    batteryMasterInfo:null
  },
  selectedBatteryForActions: {
    selectedBatteryData: [],
  },
  selectedCheckBoxState: {
    checkboxesState: [],
  },
  issuedBatteryData: {
    issuedData: []
  },
  mountLoading: {
    isLoading: false
  },
  selectedActivityRowData: {
    activityRowData: []
  },
};

const batterySlice = createSlice({
  name: "jobCardBattery",
  initialState,
  reducers: {
    batteryHasInfo: (state, { payload }) => {
      state.batteryInfo.batteryPosInfo = payload.batteryPosInfo;
      state.batteryInfo.batteryMasterInfo = payload.batteryMasterInfo
    },
    getSelectedBatteryForActions: (state, { payload }) => {
      state.selectedBatteryForActions.selectedBatteryData = payload;
    },
    getselectedBatteryCheckBoxState: (state, { payload }) => {
      state.selectedCheckBoxState.checkboxesState = payload;
    },
    getSelectedBatActivityRowData: (state, { payload }) => {
      state.selectedActivityRowData.activityRowData = payload;
    },
    getIssuedBatteryData: (state, { payload }) => {
      state.issuedBatteryData.issuedData = payload;
    },
    batteryMountLoading: (state, { payload }) => {
      state.mountLoading.isLoading = payload;
    },

  },
});

const { reducer, actions } = batterySlice;

export const {
  batteryHasInfo,
  getSelectedBatteryForActions,
  getselectedBatteryCheckBoxState,
  getSelectedBatActivityRowData,
  getIssuedBatteryData,
  batteryMountLoading
} = actions;

export default reducer;
